import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTutorialTileEntity extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD_TUTORIAL;
}

export default DirtRoadTutorialTileEntity;
